import React, { useState, useEffect } from 'react';
import Sidemenu from '../base/sidemenu';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { formatMobilePhone, formatOfficePhone } from '../../utils/phoneFormatter'
export default function AdminEdit() {
  const location = useLocation();
  const navigate = useNavigate();
  const admin = location.state?.admin || {};
  console.log("location.state.admin 값:", admin);
  const [deptList, setDeptList] = useState([]);
  const [authList, setAuthList] = useState([]);
  useEffect(() => {
    console.log("초기 상태값들:", {
      id, username, name, auth, email, department, phone, mobile_phone, password,
    });
  }, []);
  // 상태 관리
  const [id] = useState(admin.id || "");
  const [username, setUsername] = useState(admin.username || "");
  const [password, setPassword] = useState(admin.password || ""); // 기존 비밀번호는 빈값으로 두고, 변경 시에만 입력 받음
  const [new_password, setNewPassword] = useState("");
  const [name, setName] = useState(admin.name || "");
  const [auth, setAuth] = useState(admin.auth_name || "");
  const [email, setEmail] = useState(admin.email || "");
  const [department, setDepartment] = useState(admin.department || "");
  const [phone, setPhone] = useState(admin.phone || "");
  const [mobile_phone, setMobile_phone] = useState(admin.mobile_phone || "");


  // 로그인한 사용자의 권한 디코딩
  const decodeToken = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error("토큰 디코딩 실패:", error);
      return null;
    }
  };
  const token = localStorage.getItem("token");
  const decoded = decodeToken(token);
  const loginAuth = decoded?.auth;

  // 소속, 권한 목록 API 호출 (필요시 경로 조정)
  useEffect(() => {
    const fetchSelectLists = async () => {
      try {
        const [authRes, deptRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/auth`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/department`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setAuthList(Array.isArray(authRes.data) ? authRes.data : authRes.data.auth || []);
        setDeptList(Array.isArray(deptRes.data) ? deptRes.data : deptRes.data.department || []);
      } catch (error) {
        console.error("선택박스 데이터 불러오기 실패:", error);
        alert("소속 또는 권한 정보를 불러오는 데 실패했습니다.");
      }
    };

    fetchSelectLists();
  }, [token]);

  //
  const handleMobilePhoneChange = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatMobilePhone(inputValue);
    setMobile_phone(formattedValue);
  };

  const handleOfficePhoneChange = (e) => {
    const inputValue = e.target.value;
    const formatted = formatOfficePhone(inputValue);
    setPhone(formatted);
  };


  // 수정 요청
  const handleUpdate = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };

      const selectedAuth = authList.find(a => a.name === auth);
      const selectedDept = deptList.find(d => d.name === department);

      const body = {
        id,
        username,
        password,
        new_password,
        name,
        auth: selectedAuth?.id || 2,
        email,
        department: selectedDept?.id || "",
        phone,
        mobile_phone
      };
      console.log("authList", authList);
      console.log("선택된 auth 이름:", auth);
      console.log("선택된 auth ID:", selectedAuth?.id);

      const response = await axios.put("https://safemap-api.smsoft.co.kr/admin", body, config);

      if (response.data.success === false) {
        alert(response.data.message);
        return;
      }
      alert(response.data.message);
      navigate("/admin");
    } catch (error) {
      console.error("수정 요청 실패:", error);
      alert("수정 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className='flex'>
      <Sidemenu />
      <div className="admin">
        <h1>관리자 관리</h1>
        <div className='admin_box'>
          <h2 className="subpage_title"><span className="before"><span className="nametit">{name}</span> 수정</span></h2>
          <div className='admin_edit'>
            <div className='table02'>
              <table>
                <caption>관리자 수정 표</caption>
                <colgroup>
                  <col width="20%" />
                  <col width="80%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope='row'>이름</th>
                    <td><input type="text" value={name} onChange={e => setName(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>아이디</th>
                    <td><input type="text" value={username} onChange={e => setUsername(e.target.value)} disabled /></td>
                  </tr>
                  <tr>
                    <th scope='row'>현재 비밀번호</th>
                    <td><input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="비밀번호 변경 시, 기존의 비밀번호를 입력하세요." /></td>
                  </tr>
                  <tr>
                    <th scope='row'>새 비밀번호</th>
                    <td><input type="password" value={new_password} onChange={e => setNewPassword(e.target.value)} placeholder="변경할 새 비밀번호를 입력하세요. " /></td>
                  </tr>
                  <tr>
                    <th scope='row'>휴대폰 번호</th>
                    <td><input type="text" value={mobile_phone} onChange={handleMobilePhoneChange} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>내선 번호</th>
                    <td><input type="text" value={phone} onChange={handleOfficePhoneChange} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>이메일</th>
                    <td><input type="text" value={email} onChange={e => setEmail(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>소속</th>
                    <td>
                      {loginAuth === 1 ? (
                        <select value={department} onChange={e => setDepartment(e.target.value)}>
                          <option value="" disabled>선택</option>
                          {deptList.map((item) => (
                            <option key={item.id} value={item.name}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span>{department}</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>권한</th>
                    <td>
                      {loginAuth === 1 ? (
                        <select value={auth} onChange={e => setAuth(e.target.value)}>
                          <option value="" disabled>선택</option>
                          {authList.map((auth) => (
                            <option key={auth.id} value={auth.name}>
                              {auth.name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span>{auth}</span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="btn-group">
              <button className="btncolor02" onClick={() => navigate(-1)}>뒤로</button>
              <button className="btncolor01" onClick={handleUpdate}>수정완료</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
